import { ClockIcon } from '@heroicons/react/20/solid';
import { ActionButton } from '../../../../components/buttons/ActionButton';
import { GroupButton } from '../../../../components/buttons/GroupButton';
import { DateRangePickerComponent } from '../../../../components/others/DateRangePickerComponent';
import { getVACAeroDashboardPeriodRange } from '../../../../services/dashboard/vacaero-dashboard-service';

export const VACAeroDashboardFilters = ({ pieces, value, onChange }) => {
  const handleRangeShortcut = (rangeKey) => {
    onChange(getVACAeroDashboardPeriodRange(rangeKey, pieces));
  };

  const handleCustomRange = (start, end) => {
    onChange({
      start: Math.floor(start.getTime() / 1000),
      end: Math.floor(end.getTime() / 1000),
      rangeKey: 'custom',
    });
  };

  const selectedRangeIndex = ['last_24h', 'last_7d', 'last_30d', 'all'].indexOf(value.rangeKey);

  return (
    <div className="rounded-md bg-perception-black-500 p-4">
      <div className="flex flex-wrap items-end gap-4">
        <div className="flex flex-col gap-2">
          <div className="text-xs font-semibold uppercase text-perception-gray-600">
            Période
          </div>

          <GroupButton
            selected={selectedRangeIndex >= 0 ? selectedRangeIndex : null}
            size="sm"
            buttons={[
              {
                text: 'Dernières 24 heures',
                color: value.rangeKey === 'last_24h' ? 'primary' : 'secondary',
                onClick: () => handleRangeShortcut('last_24h'),
              },
              {
                text: '7 derniers jours',
                color: value.rangeKey === 'last_7d' ? 'primary' : 'secondary',
                onClick: () => handleRangeShortcut('last_7d'),
              },
              {
                text: '30 derniers jours',
                color: value.rangeKey === 'last_30d' ? 'primary' : 'secondary',
                onClick: () => handleRangeShortcut('last_30d'),
              },
              {
                text: 'Toutes les données',
                color: value.rangeKey === 'all' ? 'primary' : 'secondary',
                onClick: () => handleRangeShortcut('all'),
              },
            ]}
          />
        </div>

        <DateRangePickerComponent
          key={`${value.start}-${value.end}`}
          defaultStart={new Date(value.start * 1000)}
          defaultEnd={new Date(value.end * 1000)}
          callback={handleCustomRange}
          validateText="Appliquer"
          cancelText="Annuler"
          trigger={({ isCalendarOpen, setIsCalendarOpen }) => (
            <ActionButton
              text="Période personnalisée"
              Icon={ClockIcon}
              color={value.rangeKey === 'custom' ? 'primary' : 'secondary'}
              size="sm"
              onClick={() => setIsCalendarOpen(!isCalendarOpen)}
            />
          )}
        />
      </div>
    </div>
  );
};